export default "__VITE_ASSET__BAoxPT48__"